
import { defineComponent, computed } from 'vue';
import IconComponent from './IconComponent.vue';

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
        },
        disabledUp: {
            type: Boolean,
        },
        disabledDown: {
            type: Boolean,
        },
    },
    components: {
        IconComponent,
    },
    emits: ['pressed'],
    setup(props, { emit }) {
        const classAtt = computed(() => {
            const state = {
                'bg-neutrals-50 hover:bg-neutrals-100 active:bg-neutrals-200': !props.disabled,
                'bg-neutrals-50': props.disabled,
            };
            return {
                ...state,
            };
        });

        const onPressed = (type: string) => {
            if ((type == 'up' && !props.disabledUp) || (type == 'down' && !props.disabledDown)) emit('pressed', type);
        };

        return {
            classAtt,
            onPressed,
        };
    },
});
